import React, { useRef } from 'react';
import { MenuItem } from '../../../components/Menu';
import addIcon from '../../../icons/non-prefilled/16x16/add.svg';
import * as styles from './AddAttachmentMenuItem.module.scss';
import { useToolbarOverflowMenuClose } from './Toolbar';

interface AddAttachmentMenuItemProps {
  onUpload: React.ChangeEventHandler<HTMLInputElement>;
}

const AddAttachmentMenuItem = ({ onUpload }: AddAttachmentMenuItemProps) => {
  const inputRef = useRef<HTMLInputElement>(null);
  const closeOverflowMenu = useToolbarOverflowMenuClose();

  return (
    <>
      <input
        type="file"
        ref={inputRef}
        onChange={(event) => {
          onUpload(event);
          closeOverflowMenu();
        }}
        className={styles.input}
        multiple
        aria-labelledby="aria-add-attachment-menu-item"
      />
      <MenuItem
        icon={addIcon}
        onClick={() => inputRef.current?.click()}
        id="aria-add-attachment-menu-item"
      >
        Add more files
      </MenuItem>
    </>
  );
};

export default AddAttachmentMenuItem;
